import weui from 'weui.js'
import i18n from '@/lang'
import { zhThemeColor, enThemeColor } from '@/styles/variables.scss'
import BigNumber from 'bignumber.js'

/*
 * 对象重置
 * @param object object  要重置的对象
 * @param object defaultValues 默认值对象
 * @return void
 */
export function resetObject ( object, defaultValues ) {
  for(let index in object) {
    if(typeof object[index] === 'object') {
      resetObject( object[index] )
    }
    else {
      //如果有传默认值，默认值中存在该属性，并且该属性值非对象
      if(typeof defaultValues !== 'undefined' && typeof defaultValues[index] !== 'undefined' && typeof defaultValues[index] !== 'object') {
        object[index] = defaultValues[index]
      }
      else {
        object[index] = ''
      }
    }
  }
}

/*
 * 判断是否基于IOS系统，比如iphone、ipad等、mac等
 */
export function isIOS() {
  var userAgent = navigator.userAgent.toLowerCase(),
      isIpad = /ipad/.test(userAgent),
      isIphone = /iphone os/.test(userAgent),
      isMac = /mac os/.test(userAgent)
  return isIpad || isIphone || isMac;
}

export function judgeSys() {
  var u = navigator.userAgent
  var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1
  var isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
  if (isAndroid){
    return 'android'
  }else if (isIos){
    return 'IOS'
  }
}

/*
 * 判断设备是否为移动端或平板
 * @return boolean 为移动端、平板则返回true，其他则返回false
 */
function isMobileOrTablet() {
  return /phone|pad|tablet|Android|webOS|iPhone|iPod|BlackBerry|MeeGo/i.test(navigator.userAgent);
}

/*
 * 将设计宽度转换为px
 * @param int value  要转换的值
 * @return void
 */
function rpx2px(value) {
  const designDeviceWidth = 750
  let clientWidth = document.documentElement.clientWidth
  if (!isMobileOrTablet() && clientWidth > 400) clientWidth = 400;
  const ratio = Math.round(clientWidth / designDeviceWidth * 100) / 100 //当前实际宽度和设计稿给定宽度比例
  return ratio * value
}

/*
 * 封装weui的picker选择菜单
 * @param array   items    选择菜单项
 * @param object  options  菜单项配置
 * @return void
 */
export function picker(items, options = {}) {
  if (!options.rowHeight) {
    options.rowHeight = rpx2px(70); //70是设计稿给出的选项高度
  }
  weui.picker(items, options)
}

/*
 * 根据设备独立像素比，返回对应的图片
 * @return string
 */
function getIconExt() {
  const dpr = window.devicePixelRatio
  var iconExt = ''
  if (dpr >= 1.5 && iconExt < 2.5) {
    iconExt = '@2x'
  } else if (iconExt >= 2.5) {
    iconExt = '@3x'
  }
  return iconExt + '.png'
}

export let iconExt = getIconExt()

/*
 * 可以保留两位小数的字段校验是否为0，为0时，给出错误提示。作为async validator的校验规则rules
 * @param string fieldName 字段名称
 * @return function
 */
export function validatorZero(fieldName) {
  fieldName = fieldName || ''
  return function validator(rule, value, callback, source, option) {
      var errors = []
      if(parseInt(value*100) === 0) {
        errors.push( new Error( i18n.t('error.cannotBeZero', {field: fieldName}) ))
      }
      return errors
    }
}

/*
 * 乘法函数，用来得到精确的乘法结果
 * 说明：javascript的乘法结果会有误差，在两个浮点数相乘的时候会比较明显。这个函数返回较为精确的乘法结果。
 * @param number arg1
 * @param number arg2
 * @return number
 */
export function accMul(arg1, arg2) {
  let m = 0,
      s1 = arg1.toString(),
      s2 = arg2.toString(),
      num1, num2
  try {
    if(!/e/.test(s1)) {
      m += s1.split(".")[1].length
    }
  }
  catch(e) {
  }
  try {
    if(!/e/.test(s2)) {
      m += s2.split(".")[1].length
    }
  }
  catch(e) {
  }

  num1 = /e/.test(s1) ? Number(s1) : Number(s1.replace('.', ''))
  num2 = /e/.test(s2) ? Number(s2) : Number(s2.replace('.', ''))
  return num1 * num2 / Math.pow(10, m)
}

/*
 * 除法函数，用来得到精确的除法结果
 * 说明：javascript的除法结果会有误差，在两个浮点数相除的时候会比较明显。这个函数返回较为精确的除法结果。
 * @param number arg1
 * @param number arg2
 * @return number
 */
export function accDiv(arg1, arg2) {
  let t1 = 0, t2 = 0,
      s1 = arg1.toString(),
      s2 = arg2.toString(),
      num1, num2
  try {
    if(!/e/.test(s1)) {
      t1 = s1.split(".")[1].length //获取小数位数
    }
  }
  catch (e) {
  }
  try {
    if(!/e/.test(s2)) {
      t2 = s2.split(".")[1].length
    }
  }
  catch (e) {
  }

  num1 = /e/.test(s1) ? Number(s1) : Number(s1.replace(".", "")) //转换成整数
  num2 = /e/.test(s2) ? Number(s2) : Number(s2.replace(".", ""))
  return (num1 / num2) * Math.pow(10, t2 - t1)
}

/*
 * 大数乘法运算，用来得到精确的除法结果。支持传入多个数值
 * @param number arg1-argN  数值，可以传多个
 * @return string
 */
export function bigNumberMul() {
  if (arguments.length <= 1) return arguments[0]
  let result = BigNumber(arguments[0])
  for (var i = 1, len = arguments.length; i < len; i++) {
    result = result.multipliedBy(arguments[i])
  }

  return result.toString()
}

/*
 * 大数除法运算，用来得到精确的除法结果。支持传入多个数值，第一个作为被除数，后面作为除数
 * @param number arg1-argN  数值，可以传多个
 * @return string
 * @return string
 */
export function bigNumberDiv() {
  if (arguments.length <= 1) return arguments[0]

  let result = BigNumber(arguments[0])
  for (var i = 1, len = arguments.length; i < len; i++) {
    result = result.dividedBy(arguments[i])
  }

  return result.toString()
}

/**
 * 大数保留小数点后n位
 * @param {string} method 小数保留方法，'floor' | 'round'，默认'floor'。分别表示向下取整，四舍五入
 * @param {number} num 数值
 * @param {number} precision 保留的小数位数，默认2位
 * @returns 
 */
export function toPrecision(method, num,  precision = 2) {
  let bigNum = BigNumber(num)
  if (method === 'floor') {
    bigNum = bigNum.decimalPlaces(precision, BigNumber.ROUND_DOWN);
  } else if (method === 'round') {
    bigNum = bigNum.toPrecision(precision)
  }
  return typeof num === 'string' ? bigNum.toString() : bigNum.toNumber()
}

/*
 * 从hash上获取目标参数
 * @param {string} target  目标参数
 * @return {string} data  返回目标参数的值
 */
export function getTargetFromHash(target) {
  let param = ''
  if (location.hash) {
    // 获取问号出现的位置
    const index = location.hash.indexOf('?')
    // 获取问号后所有的参数字符串
    const allParam =  location.hash.substring(index + 1)
    // 以&分割后的数组
    const attrs = allParam.split('&')
    // 过滤目标参数
    const params = attrs.filter(item => item.split('=')[0] === target )
    // 获取目标参数的值
    const targetArr = params.length > 0 ? params[0].split('=') : []
    param = targetArr[1] ? targetArr[1] : ""
  }
  return param
}

/*
 * 检验色值是否有效
 * @param {number}   themeColor 颜色色值的数字
 * @return {boolean}  true 符合检验规则，false不符合检验规则
 */
export function checkThemeColor(themeColor) {
  // 正则匹配颜色色值,支持简写的颜色色值
  const regColor = /^([A-F\d]{6}|[A-F\d]{3})$/i
  const match = themeColor.match(regColor)
  return match ? true : false
}

/*
 * 设置主题色
 * @return void
 */
export function setThemeColor() {
  // 获取主题颜色
  const colorNumber = getTargetFromHash('themeColor')
  // 获取默认主题颜色
  let defaultThemeColor = enThemeColor
  if (process.env.LANG === "zh" || process.env.LANG === "cosZh") {
    defaultThemeColor = zhThemeColor
  }
  const themeColor = checkThemeColor(colorNumber) ? `#${colorNumber}` : defaultThemeColor
  // 在root上添加新的属性，用于设置主题色
  const root = document.documentElement
  root.style.setProperty('--theme-color', themeColor)
}



// WEBPACK FOOTER //
// ./src/utils/index.js